import { Component, OnInit } from '@angular/core';
import { Section } from 'src/app/classes/section';
import { SectionService } from 'src/app/services/section.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { accordeonMe } from 'src/app/animations';


@Component({
	selector: 'app-section-management',
	templateUrl: './section-management.component.html',
	styleUrls: [ './management-interface.css', 'accordeon-ui.scss' ],
	animations: [ accordeonMe ],
})
export class SectionManagementComponent implements OnInit {


	elements: Section[] = [];
	currentFilter = "";
	filteredElements: Section[] = [];
	expandedElementId = "";

	sortingField = 'sparteBezeichnung';
	sortingAsc = true;

	bLoading = true;


	constructor(
		private sectionService: SectionService,
		private matDialog: MatDialog
	) {}


	ngOnInit() {

		this.sectionService.getAll().subscribe( sections => {
			this.bLoading = false;
			this.elements = sections;
			this.sortElements();
		});

	}



	sortColumn( field: string ) {

		if( this.sortingField === field ) {
			this.sortingAsc = !this.sortingAsc;
		} else {
			this.sortingField = field;
			this.sortingAsc = true;
		}

		this.sortElements();

	}

	sortElements() {

		this.elements.sort( ( a, b ) => {

			const valueA = (a[this.sortingField] || '').toString();
			const valueB = (b[this.sortingField] || '').toString();
		
			return this.sortingAsc ? valueA.localeCompare( valueB ) : valueB.localeCompare( valueA );

		});

		this.applyFilter();

	}

	clickOnRow( elementId: string ) {

		const bPrevious = !!this.expandedElementId;

		this.expandedElementId = ( this.expandedElementId == elementId ) ? "" : elementId;

		if( bPrevious && this.expandedElementId ) {
			setTimeout( () => {
				const elem = window.document.getElementById( "elementRow_" + elementId );
				if( elem ) {
					elem.scrollIntoView( { behavior: "smooth", block: "start" } );
				}
			}, 500 );
		}

	}

	onFilterChanged( event: Event ) {

		this.currentFilter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase(); 
		this.applyFilter();

	}

	private applyFilter() {

		this.filteredElements = this.elements.filter( u => {

			for( const searchField of [ "sparteBezeichnung", "sparteBeshreibung" ] ) {

				if( !u[ searchField ] ) continue;
				const str = ("" + u[ searchField ]).toLowerCase();
				if( str.includes( this.currentFilter ) ) return true;

			}

			return false;

		});

	}

	showCreationDialog() {

		this.matDialog.open( SectionCreatorDialog, { maxHeight: '90vh' } ).afterClosed().subscribe( section => {

			if( section && section.sparteId ) {
				this.elements.push( section );
				this.sortElements();
			}
		});
		
	}

}



@Component( {
	selector: 'section-creator-dialog',
	template: `<app-section-editor (done)="creationDone($event)" />`
})
export class SectionCreatorDialog {

	constructor(
		public dialogRef: MatDialogRef<SectionCreatorDialog>,
	) {}

	creationDone( section: Section ) {
		this.dialogRef.close( section );
	}

}
